module.exports = __webpack_public_path__ + "static/media/journey-level-1-top.04a94e6a.png";